'use client'
import {Badge, BadgeDot} from "@/components/atoms/badges";
import {SubTitle} from "@/components/atoms/typographies";
import {ResolveLabel} from "@/lib/tools/objects";
import {Item, Lodging, LodgingHead} from "@/lib/types";
import Image from "next/image";
import Link from "next/link";
import {Skeleton} from "primereact/skeleton";
import styled from "styled-components";

import {OptionKeys} from "@/lib/tools/options";

const StyledSkeleton = styled(Skeleton)`
    margin: 5px;
    display: inline-block;
`

const StyledItem = styled.div`
    border-bottom: 1px solid ${props => props.theme.border.color};
    display: flex;
    padding: ${props => props.theme.padding * 2}px;
    margin: ${props => props.theme.padding}px;
    border-radius: ${props => props.theme.border.radius};
    background-color: ${props => props.theme.surfaces.surface0};
    flex-direction: column;

    &:hover {
        background-color: ${props => props.theme.surfaces.surface2};
    }

    .list-picture {
        background-color: ${props => props.theme.surfaces.surface2};
        width: 100%;
        height: 250px;
        position: relative;

        img {
            object-fit: cover;
            border-radius: ${props => props.theme.border.radius};
        }
    }

    .list-placeholder {
        width: 100%;
    }

    /* @media device.tablet {
      flex-direction: row;
      .list-picture{
        width: 450px;
        height:200px;
      }
    } */
`

export const LodgingCard = ({lodging, lodgings, pets, equipments}: {
  lodging: Lodging | LodgingHead,
  lodgings: Item[],
  pets: Item[],
  equipments: Item[]
}) => {

  const optionMap: { [key: string]: boolean } = {}
  lodging.lodging_options.forEach(o => {
    optionMap[o.option_key] = true
  })

  const subPets = lodging.lodging_pets.split(',').slice(0, 5)
  return <Link href={"/lodgings/" + lodging.lodging_slug + "/" + lodging.lodging_id}
               key={'lodging-' + lodging.lodging_id}>
    <div className={"flex flex-col bg-white rounded-lg m-1 overflow-hidden hover:shadow-sm hover:bg-neutral-50"}>
      <div className="w-full h-48  relative overflow-hidden bg-gray-50 ">
        <Image fill={true} style={{objectFit: "cover"}} className="z-5"
               src={lodging.lodging_media_url ? lodging.lodging_media_url+'?format=webp&scale=500&quality=100' : "/images/logo.png"}
               alt={lodging.lodging_title}/>
      </div>
      <div className="w-full flex flex-col h-60">
        <div className="flex flex-row align-middle items-center ">
          <div>
            <h2 className="text-black pb-2 pt-2 pl-2 text-2xl">{lodging.lodging_title}</h2>
            <p
              className="text-sm pl-2 pb-2 col-span-1">{lodging.location_department_name}, {lodging.location_city_name}</p>
          </div>
          <div className="grow "></div>
          {/*<div className="flex-none justify-end "><Badge title={"Prix"}*/}
          {/*                                               className="bg-yellow-500 border-yellow-500 text-white">{lodging.lodging_price} €*/}
          {/*  / nuit</Badge></div>*/}
        </div>
        <div>
          <BadgeDot
            className="bg-blue-50 border-blue-400 text-blue-600">{ResolveLabel(lodging.lodging_type, lodgings)}</BadgeDot>
          <BadgeDot
            className="bg-blue-50 border-blue-400 text-blue-600">{lodging.lodging_number_adults} personnes</BadgeDot>
          <BadgeDot
            className="bg-blue-50 border-blue-400 text-blue-600">{lodging.lodging_number_pets} animaux</BadgeDot>
        </div>

        <div className="w-full grid grid-cols-3 align-middle items-center">
          {subPets.map(p => <BadgeDot className="bg-gray-100 border-gray-400 text-gray-600"
                                      key={'pets-' + lodging.lodging_id + '-' + p}>{ResolveLabel(p, pets)}</BadgeDot>)}
          {subPets.length < lodging.lodging_pets.length && <BadgeDot
              className="bg-gray-100 border-gray-400 text-gray-600 text-sm">{lodging.lodging_pets.length - subPets.length} en
              plus...</BadgeDot>}
        </div>

        <div className="flex justify-center md:flex-row ">
          {optionMap[OptionKeys.badgeAvailableNow] &&
              <Badge title={"Disponible maintenant"} className="bg-cyan-50 border-cyan-500 text-cyan-500">Disponible
                  maintenant</Badge>}
          {optionMap[OptionKeys.badgeLastDatesAvailable] &&
              <Badge title={"Derniers dates disponibles"} className="bg-orange-50 border-orange-500 text-orange-500">Derniers
                  dates disponibles</Badge>}
        </div>
      </div>

    </div>
  </Link>
}

export const RoomsSkeleton = () => {
  const item = () => <StyledItem>
    <div className={"list-picture"}>
      <StyledSkeleton width='calc(100% - 10px)' height='calc(100% - 10px)'/>
    </div>
    <div className="list-description">
      <SubTitle><StyledSkeleton width='calc(100% - 10px)'/></SubTitle>
      <p><StyledSkeleton width='%20'/> <StyledSkeleton width='20%'/> <StyledSkeleton width='20%'/> <StyledSkeleton
        width='20%'/></p>
      <div><StyledSkeleton width='calc(100% - 10px)'/></div>
      <div><StyledSkeleton width='calc(100% - 10px)'/></div>
    </div>
  </StyledItem>

  return <div>
    {item()}
  </div>
}
